<script setup lang="ts">
import templatesApi from '@/services/templates.service'
import type { PrintTemplateModel } from '@/types/models/PrintTemplateModel'
import { SelectorField } from '@rfc/rfc-components-library'
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import type { ProductRfidRollType } from '../../../types/models/ProductModel'

type Props = {
    data: ProductRfidRollType
}
defineProps<Props>()

type Emits = {
    (e: 'change', value?: ProductRfidRollType): void
}
const emit = defineEmits<Emits>()

const { t } = useI18n()

const rfidTemplates = ref<PrintTemplateModel[]>([])
const endRollTemplates = ref<PrintTemplateModel[]>([])
const loadingTemplates = ref(false)

const fetchTemplates = () => {
    loadingTemplates.value = true
    templatesApi
        .getTemplates({ per_page: 100 })
        .then(res => {
            const selectable = res.data?.filter(item => !item.is_deleted) ?? []
            rfidTemplates.value = selectable.filter(item => item.type === 'rfid_chip')
            endRollTemplates.value = selectable.filter(item => item.type === 'end_roll_label')
        })
        .finally(() => (loadingTemplates.value = false))
}

onMounted(() => fetchTemplates())

const handleChange = (value?: string | number) => {
    emit('change', { rfid_chip_template_id: value as number })
}
</script>

<template>
    <SelectorField
        :modelValue="data.rfid_chip_template_id"
        :options="rfidTemplates"
        itemValue="id"
        itemTitle="name"
        :label="t('products.model.rfidChipTemplate')"
        :placeholder="t('products.model.rfidChipTemplate')"
        clearable
        :loading="loadingTemplates"
        @change="handleChange" />

    <SelectorField
        :modelValue="data.end_roll_label_template_id"
        :options="endRollTemplates"
        itemValue="id"
        itemTitle="name"
        :label="t('products.model.endRollLabelTemplate')"
        :placeholder="t('products.model.endRollLabelTemplate')"
        clearable
        :loading="loadingTemplates"
        @change="emit('change', { end_roll_label_template_id: $event as number })" />
</template>
